import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isVendorAuthenticated, getVendorUser } from '@/lib/vendorAuth';
import { VendorRole } from '@pms/shared';

/**
 * Guards the vendor observability console (TASK-144) — a SEPARATE realm from the
 * staff app. Accepts only a vendor session (its own keychain). Unauthenticated →
 * /vendor/login (preserving destination). `adminOnly` gates team management to a
 * vendor ADMIN; a non-admin sees an inline forbidden state (handled by the page),
 * so we render children and let the page show V-FORBIDDEN when needed.
 */
export function VendorRoute({
  children,
  adminOnly = false,
}: {
  children: ReactNode;
  adminOnly?: boolean;
}) {
  const location = useLocation();
  if (!isVendorAuthenticated()) {
    return <Navigate to="/vendor/login" replace state={{ from: location }} />;
  }
  if (adminOnly && getVendorUser()?.role !== VendorRole.ADMIN) {
    return <Navigate to="/vendor" replace />;
  }
  return <>{children}</>;
}
